<template>
  <div class="wrap">
    <img src="@img/maintenance.png">
    <h2>{{tit}}</h2>
  </div>
</template>
<script>
  import {
		mapState
	} from 'vuex'
  export default {
    data() {
      return {
        tit: ''
      }
    },
    computed: {
			...mapState(['lang'])
		},
    mounted() {
      this.tit = this.$route.query.num==200?this.lang.weihu:this.lang.guanbi
    }
  }
</script>
<style scoped>
  .wrap {
    text-align: center;
    padding: 20px;
    line-height: 30px;
  }

  .wrap img {
    margin-top: 25%;
    margin-bottom: 20px;
  }
</style>